import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  margin: 0 16px 16px 16px;
  border-radius: 6px;
  background: ${vars.color.backgroundBase};
`;
